export default "__VITE_ASSET__F5aXqOGI__"